import React from "react";

export const ExclamationMarkEllipse = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="15" cy="15" r="15" fill="white" />
            <path
                d="M13.4083 16.592V5.792H16.6243V16.592H13.4083ZM13.4083 23V19.376H16.6243V23H13.4083Z"
                fill="#EC6608"
            />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/components/Icons/ExclamationMarkEllipse.tsx